<template>
  <div class="table-footer">
    <span></span>
    <div class="paginator">
      <span class="glicon-back-large" :class="{ disabled: isFirstPage }" @click="previous()"></span>
      <span>{{ $t('tables.paginatorMessage', dataSource) }}</span>
      <span class="glicon-next-large" :class="{ disabled: isLastPage }" @click="next()"></span>
    </div>
  </div>
</template>

<script>
import TableDatasource from './TableDatasource';

export default {
  name: 'TablePaginator',
  props: {
    dataSource: {
      type: Object,
      default: () => new TableDatasource()
    }
  },
  computed: {
    isFirstPage() {
      return this.dataSource.page <= 1;
    },
    isLastPage() {
      return this.dataSource.page >= this.dataSource.pages;
    }
  },
  methods: {
    previous() {
      if (!this.isFirstPage) {
        this.dataSource.refresh({
          page: Math.max(this.dataSource.page - 1, 1)
        });
      }
    },
    next() {
      if (!this.isLastPage) {
        this.dataSource.refresh({
          page: Math.min(this.dataSource.page + 1, this.dataSource.pages)
        });
      }
    }
  }
};
</script>
